module.exports = __webpack_public_path__ + "static/media/service_large_1.6106ad78.jpg";